var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-menu"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"goods-title"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"goods-material"},_vm._l((_vm.listLimit(item.children, item.broadHead)),function(itemChild){return _c('div',{key:itemChild.id,staticClass:"grid-container",attrs:{"title":itemChild.name}},[_c('RouterJumpVue',{attrs:{"to":{
            path: _vm.enumPath[itemChild.broadHead],
            query: { categoryId: itemChild.id },
          },"tag":"div","text":itemChild.name}})],1)}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }